module.exports = __webpack_public_path__ + "img/lazy_stock.2a3c1505.svg";